// import HScroll from "@koas/v-hscroll";
import CryptoJS from 'crypto-js';

export default {
  name: 'table',
  components: {},
  props: {
    isViewHidden: {
      type: Boolean,
      required: false
    },
    offset: {
      type: Number,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    width: {
      type: Boolean,
      required: false
    },
    isDelete: {
      type: Boolean,
      required: false
    },
    isEditHidden: {
      type: Boolean,
      required: false
    },
    isApprrove: {
      type: Boolean,
      required: false
    },
    isReject: {
      type: Boolean,
      required: false
    },
    columns: {
      type: Array,
      required: true
    },
    isViewDetails: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: true,
      validator: function(value) {
        let isValid = true;
        if (value.length > 0) {
          value.forEach(element => {
            if (!element['id']) {
              console.error("id is missing in payload")
              isValid = false;
            }
          });
        }
        return isValid;
      }
    },
    innerTableHeader: {
      type: Array,
      required: false
    },
    isResync: {
      type: Boolean,
      required: false
    },
    isViewImage: {
      type: Boolean,
      required: false
    },
    isViewLogs: {
      type: Boolean,
      required: false
    },
    sorting: {
      type: String,
      required: false
    },
    isExclaimation:{
      type:Boolean,
      required:false
    },
	isReuploadImage: {
		type: Boolean,
		required: false
	},
	isDownloadImage: {
		type: Boolean,
		required: false
	},
	selectCheckbox: {
		type: Boolean,
		required: false
	},
	selectall: {
		type: Boolean,
		required: false
	},
	isCloseHidden: {
		type: Boolean,
		required: false
	}
  },
  data: function() {
    return {
      opened: [],
      innerClassColumn: "col-12",
      financerole:true,
      disabledflag:false,
      ContractSelected: [],
    }
  },
  computed: {},
  created() {
    this.$root.$refs.ExpandableTable = this;
  },
  mounted() {
    this.calcucalteColumn();
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    var userrole = userdetail.rolename[0].toLowerCase();
    if (userrole.includes("finance")) {
      this.financerole = true;
    }
    this.disabledflag = (userdetail.username.toLowerCase() == 'hemant.raut@xpressbees.com'||userdetail.username.toLowerCase == 'ashish.thakare@xpressbees.com') ? true :false
  },
  methods: {
    calcucalteColumn() {
      this.innerTableHeader && this.innerTableHeader.length == 2 ? this.innerClassColumn = "col-6" : "col-12";
      this.innerTableHeader && this.innerTableHeader.length >= 3 ? this.innerClassColumn = "col-4" : "col-12";
    },
    action(type, id,event) {
      $('#tbody').children().removeClass('highlightedRow');
      $("#"+id).addClass("highlightedRow");
      this.$emit('customTableEvent', {
        actionType: type,
        id: id,
        isChecked : event && event.target.checked ? 1 :0
      })
    },
    ShowEachDetails(item, id, action) {
      $('#tbody').children().removeClass('highlightedRow');
      $("#"+id).addClass("highlightedRow");
      item.contentVisible = !item.contentVisible;
      const index = this.opened.indexOf(item.id);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [];
        this.opened.push(item.id)
      }
      //companydata.innerTableDetails = !companydata.innerTableDetails;
      //$('#innerTable' + item.id).toggle('slow');
      this.$emit('customTableEvent', {
        actionType: action || 'view',
        id: id,
      })
    },

  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/customExpandableTable/customExpandableTable.component.js